
import { X } from "phosphor-react";
import Button from "../Button";
import Modal from "../Modal";
import { DriverPreviousLicenceCheckDates } from "../../models/api/admin/driver";
import { convertDateStringToReadableString } from "../../utils/convertDateStringToReadableString";

type PreviousLicenceCheckDatesModalProps = {
    isOpen: boolean;
    onClose: () => void;
    previousLicenceCheckDates: DriverPreviousLicenceCheckDates;
};

const PreviousLicenceCheckDatesModal = ({
    isOpen,
    onClose,
    previousLicenceCheckDates,
}: PreviousLicenceCheckDatesModalProps) => {
    let content;
    if(previousLicenceCheckDates.previousLicenceCheckDateOne 
        || previousLicenceCheckDates.previousLicenceCheckDateTwo 
        || previousLicenceCheckDates.previousLicenceCheckDateThree) {
        content = (
            <div className="py-2">

                <h1>{convertDateStringToReadableString(previousLicenceCheckDates.previousLicenceCheckDateOne)}</h1>
                <h1>{convertDateStringToReadableString(previousLicenceCheckDates.previousLicenceCheckDateTwo)}</h1>
                <h1>{convertDateStringToReadableString(previousLicenceCheckDates.previousLicenceCheckDateThree)}</h1>
            </div>
        );
    } else {
            content = (
                <div className="py-2">
                    <h1>Nothing to show here.</h1>
                </div>
            );
    }
    return (
        <Modal
            isOpen={isOpen}
            onClose={() => onClose()}
            size="large"
            classNames="overflow-visible"
        >
            <form>
                <div className="p-5">
                    <div className="flex items-center justify-between">
                        <p className="text-xl font-medium">
                            Previous check dates
                        </p>
                        <X
                            size={26}
                            weight="duotone"
                            onClick={() => onClose()}
                            className="cursor-pointer"
                        />
                    </div>
                    {content}
                </div>
                <div className="flex flex-col-reverse justify-end rounded-b-sm border-t border-S2D-neutral-80 bg-S2D-neutral-90 py-3 px-6 md:flex-row">
                    <Button
                        variant="secondary"
                        onClick={() => onClose()}
                        className="w-full justify-center focus:ring-0 md:w-auto "
                    >
                        Close
                    </Button>
                </div>
            </form>
        </Modal>
    );
};

export default PreviousLicenceCheckDatesModal;
